var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortAlphaDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M447.17 202.94l-61.05-160A16 16 0 0 0 371 32h-38a15.92 15.92 0 0 0-15.1 10.94l-61.06 160a16 16 0 0 0 15.1 21.06h16.78a15.93 15.93 0 0 0 15.11-10.94L314.35 184h75.3l10.52 29.06A15.93 15.93 0 0 0 415.28 224h16.78a16 16 0 0 0 15.11-21.06zM331.73 136L352 80l20.27 56zM416 288H288a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h77.11L281 422.69a32 32 0 0 0-9 22.31v19a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-77.11L423 345.29a32 32 0 0 0 9-22.29v-19a16 16 0 0 0-16-16zm-252 96h-44V48a16 16 0 0 0-16-16H88a16 16 0 0 0-16 16v336H28a12 12 0 0 0-8.73 20.24l68 72a12 12 0 0 0 17.44 0l68-72A12 12 0 0 0 164 384z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAlphaDown);
export default __webpack_public_path__ + "static/media/sort-alpha-down.29302a95741dfd1393de05f52731cc19.svg";
export { ForwardRef as ReactComponent };